import { render } from "./BanDo.vue?vue&type=template&id=72fad034&scoped=true"
import script from "./BanDo.vue?vue&type=script&lang=js"
export * from "./BanDo.vue?vue&type=script&lang=js"

import "./BanDo.vue?vue&type=style&index=0&id=72fad034&scoped=true&lang=scss"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fad034"]])

export default __exports__